import React, { Fragment, FunctionComponent, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { ERROR_CODES, NOT_AUTHORIZED_ERROR, OTP_EXHAUSTED } from '../../constants/constants';
import "./error.scss"
import AxisButton from '../../components/button/button';
import Text from '../../components/typography/typgraphy';
import { LOGOUT } from '../../constants/messages';
import { getTransactionIdFromURL, isCommonErrorPage, isUserLoggedIn, logoutUser } from '../../constants/utils';
import errorIcon from '../../assets/images/error.svg'
import Demogicon from '../../assets/images/demogError.png'
import Ibicon from '../../assets/images/ibError.png'
import Otpicon from '../../assets/images/otpError.png'
import Arcicon from '../../assets/images/arcError.png'
import Aumicon from '../../assets/images/aumError.png'
import Connecticon from '../../assets/images/connectError.png'

import ConstituionError from './commonPages/constitutionError';
import InactiveAccountError from './commonPages/inactiveAccountError';
import InvalidAccountError from './commonPages/invalidAccountError';
import InvalidSchemeCodeError from './commonPages/invalidSchemeCodeError';
import NoAccountError from './commonPages/noAccountError';
import VintageError from './commonPages/vintageError';
import UnderageError from './commonPages/underageError';

import UpdateKYCError from './updateAccountErrorPages/updateKYCError';
import UpdateMobileError from './commonPages/MobileError';
import UpdatePANError from './updateAccountErrorPages/updatePANError';
import DataNotFoundError from './commonPages/dataNotFoundError';
import PageNotFound from './404';
import DemogNotFoundError from './commonPages/demogNotFound';
import BenefeciaryNotFoundError from './commonPages/beneficiaryNotFoundError';
import FemaLimitExceededError from './commonPages/femaLimitExceededError';
import CommonError from './commonError';
import OTPExhausted from './commonPages/otpExhausted';
import TransactionExpired from './commonPages/transactionExpired';
import {  MPIN_ERROR_LOGOUT_GA, MPIN_ERROR_PAGELOAD_PARAM, MPIN_ERROR_PAGELOAD_VPV, pushDataLayer } from '../../constants/gaConstants';
import { useSelector } from "react-redux";
import ArcBankStatementError from './commonPages/arcBankStatementError';	
import InvalidPanMismatchCBS from './commonPages/invalidPanMismatchCBS';	
import OperAccountNotValid from './commonPages/operAccountNotValid';
import { TransactionState } from '../../core/reducers/transactionDetailsReducer';


const Error: FunctionComponent= () => {
  const history = useHistory();
  const errorState: any = history.location.state;
  const isCommonError = isCommonErrorPage()
  const txnId = getTransactionIdFromURL();
  const isAuthenticated = isUserLoggedIn(txnId);
  const [icon, setIcon] = useState(errorIcon)

  const transactionDetails = useSelector(state => state.transactionDetails)
  const auth = useSelector(state => state.auth)
  const otp = useSelector(state => state.otpReducer)
  const arc = useSelector(state => state.success)
  const aum = useSelector(state => state.profileDetails)
  const connect = useSelector(state => state.paymentSummary)
  const operAccount = useSelector(state => state.transactionDetails.submitRequest.finalAccNo)
  
  useEffect (()=>{
    if(transactionDetails.demog_error){
      setIcon(Demogicon)
    }
    if(auth.ibError){
      setIcon(Ibicon)
    }

    if(otp.otpError){
      setIcon(Otpicon)
    }

    if(arc.arcError){
      setIcon(Arcicon)
    }
    if(aum.aumError){
      setIcon(Aumicon)
    }
    if(connect.connect24Error) {
      setIcon(Connecticon)
    }
  },[transactionDetails.demog_error, auth.ibError, otp.otpError,arc.arcError,aum.aumError,connect.connect24Error])

  //useEffect for on pageload GA

  useEffect(()=>{
    switch (errorState?.errorCode) {
      case (ERROR_CODES.ACCOUNT_UPDATE_ERROR.PAN_NOT_VALID):
        pushDataLayer(MPIN_ERROR_PAGELOAD_VPV('txn-details-demog-pan-need-updated-error', 'txn details - demog - pan need updated error', '' ,txnId))
        pushDataLayer(MPIN_ERROR_PAGELOAD_PARAM('txn details - demog - pan need updated error','' ,txnId))        
        break;
      case (ERROR_CODES.COMMON.PAN_MISMATCH_WITH_CBS ):
        pushDataLayer(MPIN_ERROR_PAGELOAD_VPV('arc-pan-mismatch-error', 'arc - pan mismatch error', transactionDetails.submitRequest?.finalRemittanceAmt, txnId))
        pushDataLayer(MPIN_ERROR_PAGELOAD_PARAM('arc - pan mismatch error', transactionDetails.submitRequest?.finalRemittanceAmt, txnId))        
        break;
      case (ERROR_CODES.ACCOUNT_UPDATE_ERROR.PAN_NOT_UPDATED_WITH_CBS):
        pushDataLayer(MPIN_ERROR_PAGELOAD_VPV('arc-pan-need-updated-error', 'arc - pan need updated error', transactionDetails.submitRequest?.finalRemittanceAmt, txnId))
        pushDataLayer(MPIN_ERROR_PAGELOAD_PARAM('arc - pan need updated error', transactionDetails.submitRequest?.finalRemittanceAmt, txnId))
        break;
      case ERROR_CODES.COMMON.OPER_ACCOUNT_NOT_VALID:
        pushDataLayer(MPIN_ERROR_PAGELOAD_VPV('arc-account closed/not valid', 'arc - account closed/not valid', transactionDetails.submitRequest?.finalRemittanceAmt, txnId))
        pushDataLayer(MPIN_ERROR_PAGELOAD_PARAM('arc - account closed/not valid', transactionDetails.submitRequest?.finalRemittanceAmt, txnId))
        break;
      case ERROR_CODES.COMMON.NO_ACCOUNT_FOUND:
        pushDataLayer(MPIN_ERROR_PAGELOAD_VPV('txn-details-demog-no-valid-savings-account-error', 'txn details - demog - no valid savings account error', '', txnId))
        pushDataLayer(MPIN_ERROR_PAGELOAD_PARAM('txn details - demog - no valid savings account error', '', txnId))
        break;
      case ERROR_CODES.COMMON.MOBILE_NOT_FOUND:
        pushDataLayer(MPIN_ERROR_PAGELOAD_VPV('aum-mobile-number-could-not-found-error', 'aum - mobile number could not found error', transactionDetails.submitRequest?.finalRemittanceAmt, txnId))
        pushDataLayer(MPIN_ERROR_PAGELOAD_PARAM('aum - mobile number could not found error', transactionDetails.submitRequest?.finalRemittanceAmt, txnId))
        break;
      case ERROR_CODES.COMMON.ARC_BANK_STATEMENT_ERR:
        pushDataLayer(MPIN_ERROR_PAGELOAD_VPV('perfios-complete-cannot-generate-report-error', 'perfios complete - cannot generate report error', transactionDetails.submitRequest?.finalRemittanceAmt, txnId))
        pushDataLayer(MPIN_ERROR_PAGELOAD_PARAM('perfios complete - cannot generate report error', transactionDetails.submitRequest?.finalRemittanceAmt, txnId))
        break;
      case ERROR_CODES.COMMON.FEMA_LIMIT_ERROR:
        pushDataLayer(MPIN_ERROR_PAGELOAD_VPV('arc-lrs-limit-breached-error', 'arc - lrs limit breached error', transactionDetails.submitRequest?.finalRemittanceAmt, txnId))
        pushDataLayer(MPIN_ERROR_PAGELOAD_PARAM('arc - lrs limit breached error', transactionDetails.submitRequest?.finalRemittanceAmt, txnId))
        break;
      case OTP_EXHAUSTED:
        pushDataLayer(MPIN_ERROR_PAGELOAD_VPV('otp-3-wrong-otp', 'otp - 3 wrong otp', transactionDetails.submitRequest?.finalRemittanceAmt, txnId))
        pushDataLayer(MPIN_ERROR_PAGELOAD_PARAM('otp - 3 wrong otp', transactionDetails.submitRequest?.finalRemittanceAmt, txnId))
        break;
      case ERROR_CODES.COMMON.UNDERAGE:
        pushDataLayer(MPIN_ERROR_PAGELOAD_VPV('txn-details-demog-customer-is-minor', 'txn details - demog - customer is minor', '', txnId))
        pushDataLayer(MPIN_ERROR_PAGELOAD_PARAM('txn details - demog - customer is minor', '', txnId))
        break;
      case ERROR_CODES.COMMON.DATA_NOT_FOUND:
        pushDataLayer(MPIN_ERROR_PAGELOAD_VPV('txn-details-demog-sa-account-data-not-available', 'txn details - demog - sa account data not available', '', txnId))
        pushDataLayer(MPIN_ERROR_PAGELOAD_PARAM('txn details - demog - sa account data not available', '', txnId))
        break;
      case ERROR_CODES.COMMON.INVALID_CONSTITUTION_CODE:
        pushDataLayer(MPIN_ERROR_PAGELOAD_VPV('txn-details-demog-invalid-constitution-code', 'txn details - demog - invalid constitution code', '', txnId))
        pushDataLayer(MPIN_ERROR_PAGELOAD_PARAM('txn details - demog - invalid constitution code', '', txnId))
        break;
      case ERROR_CODES.COMMON.INVALID_SCHEME_CODE:
        pushDataLayer(MPIN_ERROR_PAGELOAD_VPV('txn-details-demog-invalid-scheme-code', 'txn details - demog - invalid scheme code', '', txnId))
        pushDataLayer(MPIN_ERROR_PAGELOAD_PARAM('txn details - demog - invalid scheme code', '', txnId))
        break;
      case ERROR_CODES.COMMON.ACCOUNT_NOT_ACTIVE:
        pushDataLayer(MPIN_ERROR_PAGELOAD_VPV('txn-details-demog-account-needs-to-be-reactivated', 'txn details - demog - account needs to be reactivated', '', txnId))
        pushDataLayer(MPIN_ERROR_PAGELOAD_PARAM('txn details - demog - account needs to be reactivated', '', txnId))
        break;
      case ERROR_CODES.ACCOUNT_UPDATE_ERROR.KYC_NOT_DONE:
        pushDataLayer(MPIN_ERROR_PAGELOAD_VPV('txn-details-demog-kyc-incomplete', 'txn details - demog - kyc incomplete', '', txnId))
        pushDataLayer(MPIN_ERROR_PAGELOAD_PARAM('txn details - demog - kyc incomplete', '', txnId))
        break;
      default:
        break;
    }
  },[errorState?.errorCode])

  // GA on Logout
  const handleLogout = () => {
    switch (errorState?.errorCode) {
      case (ERROR_CODES.ACCOUNT_UPDATE_ERROR.PAN_NOT_VALID):
        pushDataLayer(MPIN_ERROR_LOGOUT_GA('txn details - demog - pan need updated error', '', txnId))
        break;
      case (ERROR_CODES.COMMON.PAN_MISMATCH_WITH_CBS ):
        pushDataLayer(MPIN_ERROR_LOGOUT_GA('arc - pan mismatch error', transactionDetails.submitRequest?.finalRemittanceAmt, txnId))
        break;
      case (ERROR_CODES.ACCOUNT_UPDATE_ERROR.PAN_NOT_UPDATED_WITH_CBS):
        pushDataLayer(MPIN_ERROR_LOGOUT_GA('arc - pan need updated error', transactionDetails.submitRequest?.finalRemittanceAmt, txnId))
        break;
      case ERROR_CODES.COMMON.OPER_ACCOUNT_NOT_VALID:
        pushDataLayer(MPIN_ERROR_LOGOUT_GA('arc - account closed/not valid', '',txnId))
        break;
      case ERROR_CODES.COMMON.NO_ACCOUNT_FOUND:
        pushDataLayer(MPIN_ERROR_LOGOUT_GA('txn details - demog - no valid savings account error', transactionDetails.submitRequest?.finalRemittanceAmt, txnId))
        break;
      case ERROR_CODES.COMMON.MOBILE_NOT_FOUND:
        pushDataLayer(MPIN_ERROR_LOGOUT_GA('aum - mobile number could not found error', transactionDetails.submitRequest?.finalRemittanceAmt, txnId))
        break;
      case ERROR_CODES.COMMON.ARC_BANK_STATEMENT_ERR:
        pushDataLayer(MPIN_ERROR_LOGOUT_GA('perfios complete - cannot generate report error', transactionDetails.submitRequest?.finalRemittanceAmt, txnId))
        break;
      case ERROR_CODES.COMMON.FEMA_LIMIT_ERROR:
        pushDataLayer(MPIN_ERROR_LOGOUT_GA('arc - lrs limit breached error', transactionDetails.submitRequest?.finalRemittanceAmt, txnId))
        break;
      case OTP_EXHAUSTED:
        pushDataLayer(MPIN_ERROR_LOGOUT_GA('otp - 3 wrong otp', transactionDetails.submitRequest?.finalRemittanceAmt, txnId))
        break;
      case ERROR_CODES.COMMON.UNDERAGE:
        pushDataLayer(MPIN_ERROR_LOGOUT_GA('txn details - demog - customer is minor', '', txnId))
        break;
      case ERROR_CODES.COMMON.DATA_NOT_FOUND:
        pushDataLayer(MPIN_ERROR_LOGOUT_GA('txn details - demog - sa account data not available', '', txnId))
        break;
      case ERROR_CODES.COMMON.INVALID_CONSTITUTION_CODE:
        pushDataLayer(MPIN_ERROR_LOGOUT_GA('txn details - demog - invalid constitution code', '', txnId))
        break;
      case ERROR_CODES.COMMON.INVALID_SCHEME_CODE:
        pushDataLayer(MPIN_ERROR_LOGOUT_GA('txn details - demog - invalid scheme code', '', txnId))
        break;
      case ERROR_CODES.COMMON.ACCOUNT_NOT_ACTIVE:
        pushDataLayer(MPIN_ERROR_LOGOUT_GA('txn details - demog - account needs to be reactivated', '', txnId))
        break;
      case ERROR_CODES.ACCOUNT_UPDATE_ERROR.KYC_NOT_DONE:
        pushDataLayer(MPIN_ERROR_LOGOUT_GA('txn details - demog - kyc incomplete', '', txnId))
        break;
      default:
        break;
    }
    logoutUser()
  }


  const renderErrorPage = (errorCode = 0, partnerName = "") => {
    let isAccountErrorPage = Object.values(ERROR_CODES.ACCOUNT_UPDATE_ERROR).includes(errorCode)
    if (isAccountErrorPage) {
      return returnUpdateAccountErrorPage(errorCode, partnerName)
    } else {
      return (
        <div className="error-container">
          <div className="error-wrapper">
            <div className="error-description-container">
              <img className="error-icon" src={icon} alt="error" />
              <Text className="error-heading">Uh Oh!</Text>
              <Text className="error-sub-heading">We are Sorry!</Text>
              {returnCommonErrorPage(errorCode, partnerName, operAccount)}
            </div>
            {isAuthenticated && (
              <div className="logout-container">
                <AxisButton onClick={handleLogout} disableElevation customStyle={"submit-btn-primary"} variant="contained">
                  <Text className={"submit-btn-text"}>{LOGOUT}</Text>
                </AxisButton>
              </div>
            )}
          </div>
        </div>
      )
    }
  }

  const returnUpdateAccountErrorPage = (errorCode: number, partnerName: string) => {
    switch (errorCode) {
      case ERROR_CODES.ACCOUNT_UPDATE_ERROR.KYC_NOT_DONE:
        return <UpdateKYCError partnerName={partnerName} />
      case ERROR_CODES.ACCOUNT_UPDATE_ERROR.PAN_NOT_VALID:
        return <UpdatePANError partnerName={partnerName} />
      case ERROR_CODES.ACCOUNT_UPDATE_ERROR.PAN_NOT_UPDATED_WITH_CBS:
        return <UpdatePANError partnerName={partnerName} />
    }
  }

  const returnCommonErrorPage = (errorCode: number, partnerName: string, operAccount: string) => {
    switch (errorCode) {
      case ERROR_CODES.COMMON.PAN_MISMATCH_WITH_CBS:
        return <InvalidPanMismatchCBS/>
      case ERROR_CODES.COMMON.OPER_ACCOUNT_NOT_VALID:
        return <OperAccountNotValid operAccount={operAccount}/>
      case ERROR_CODES.COMMON.ACCOUNT_NOT_ACTIVE:
        return <InactiveAccountError />
      case ERROR_CODES.COMMON.ARGO_INVALID_ACCOUNT:
        return <InvalidAccountError />
      case ERROR_CODES.COMMON.CUSTOMER_VINTAGE_EXCEPTION:
        return <VintageError />
      case ERROR_CODES.COMMON.DATA_NOT_FOUND:
        return <DataNotFoundError />
      case ERROR_CODES.COMMON.INVALID_CONSTITUTION_CODE:
        return <ConstituionError />
      case ERROR_CODES.COMMON.INVALID_SCHEME_CODE:
        return <InvalidSchemeCodeError />
      case ERROR_CODES.COMMON.NO_ACCOUNT_FOUND:
        return <NoAccountError />
      case ERROR_CODES.COMMON.UNDERAGE:
        return <UnderageError />
      case ERROR_CODES.COMMON.MOBILE_NOT_FOUND:
        return <UpdateMobileError />
      case ERROR_CODES.COMMON.ARC_BANK_STATEMENT_ERR:
      	return <ArcBankStatementError />
      case ERROR_CODES.COMMON.DEMOG_NOT_FOUND:
        return <DemogNotFoundError partnerName={partnerName} />
      case ERROR_CODES.COMMON.BENEFICIARY_NOT_FOUND:
        return <BenefeciaryNotFoundError partnerName={partnerName} />
      case ERROR_CODES.COMMON.FEMA_LIMIT_ERROR:
        return <FemaLimitExceededError />
      case OTP_EXHAUSTED:
        return <OTPExhausted partnerName={partnerName} />
      case NOT_AUTHORIZED_ERROR.code:
        return <TransactionExpired partnerName={partnerName} />
      default:
        return <CommonError />
    }
  }


  const renderErrorPageFragment = () => {
    if (isCommonError) {
      return renderErrorPage()
    }
    return errorState ? renderErrorPage(errorState.errorCode, errorState.partnerName) : <PageNotFound />
  }

  return (
    <Fragment>
      {renderErrorPageFragment()}
    </Fragment>
  )
}

export default Error;
